import { useCallback, useEffect, useState } from "react";

export const useTableExpandAll = (dataSource, rowKey, childrenColumnName) => {
  const [isAllExpanded, setIsAllExpanded] = useState(false);
  const [expandedRowIds, setExpandedRowIds] = useState([]);
  const [allKeys, setAllKeys] = useState([]);

  const getRowKey = useCallback(
    (record) => {
      if (rowKey) return rowKey(record);
      return record.id;
    },
    [rowKey]
  );

  useEffect(() => {
    const getAllGets = (item) => {
      if (childrenColumnName && item[childrenColumnName]?.length) {
        return [
          getRowKey(item),
          item[childrenColumnName].map((f) => getAllGets(f)),
        ];
      }
      return getRowKey(item);
    };

    if (dataSource) {
      const notFlatAllKeys = dataSource.map((t) => getAllGets(t));

      setAllKeys(notFlatAllKeys.flat(20));
    }
    //Adding the getRowKey in the mix causes infinite stack updates
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childrenColumnName, dataSource]);

  useEffect(() => {
    setIsAllExpanded(
      allKeys?.length === expandedRowIds?.length &&
        allKeys?.length &&
        expandedRowIds?.length
    );
  }, [allKeys, expandedRowIds]);

  const toggleRowExpanded = (expanded, record) => {
    if (expanded) {
      setExpandedRowIds(expandedRowIds.concat([getRowKey(record)]));
    } else {
      const id = getRowKey(record);
      setExpandedRowIds(expandedRowIds.filter((i) => i !== id));
    }
  };

  const expandAll = () => {
    if (!isAllExpanded) {
      if (allKeys?.length) {
        setIsAllExpanded(true);
        setExpandedRowIds(allKeys);
        return true;
      }
    }
    return false;
  };
  const collapseAll = () => {
    setIsAllExpanded(false);
    setExpandedRowIds([]);
  };

  const toggleAllExpanded = () => {
    if (isAllExpanded) collapseAll();
    else expandAll();
  };

  return {
    expandAll,
    collapseAll,
    toggleAllExpanded,
    isAllExpanded,
    tableProps: {
      dataSource,
      rowKey,
      childrenColumnName,
      expandedRowKeys: expandedRowIds,
      onExpand: toggleRowExpanded,
    },
  };
};
